import { BillData } from './bills';

export type CorpUserNumber = {
	upAccountId: string;
	accountId: string;
	billingId: string;
	accountNum: string;
	accountType: string;
	billingType: string;
};

export type UnpaidBills = {
	billsData: BillData[];
	totalUnpaid: number;
	corpUserNumber: CorpUserNumber;
};

const model: types.models.InputModel = {
	billsData: 'response.getCustomerBillsForAccountsResponse.billsData',
	totalUnpaid: 'response.getCustomerBillsForAccountsResponse.totalUnpaid',
	corpUserNumber: 'response.getCustomerBillsForAccountsResponse.corpUserNumber',
};

export default model;
